export default theme => ({
  icon: {
    marginRight: 5,
    color: theme.palette.warning.main,
    display: "inline-block",
  },
  message: {
    color: theme.palette.warning.main,
    display: "inline-block",
  },
});
